module.exports = __webpack_public_path__ + "static/media/Alegreya-Regular.fb910991.ttf";